import(/* webpackChunkName: "faqPage" */ "../../Styles/Faq/faqPage.scss");

import(/* webpackChunkName: "faqQuestion" */ "../../Styles/Faq/faqQuestion.scss");

await import(/* webpackChunkName: "ajax" */ "Feature/Common/code/Scripts/Common/ajax");